// Generado por scripts/write-build-info.mjs: no editar.
export const BUILD_INFO = {
  commitHash: "dev",
  buildTime: "2026-11-05T10:32:46.335Z",
  apiBaseUrl: "",
} as const;
